module.exports = __webpack_public_path__ + "img/cx30-21.cceab3e7.jpg";